// Title-case fallback for raw category / facet-value slugs. Splits on `-` or
// `_` and capitalises each token, e.g. `joint-and-muscle_pain-relief` ->
// `Joint And Muscle Pain Relief`.
//
// Client-safe (no server deps) so it can be shared between the PLP loaders
// (the <h1> fallback when SCAPI getCategory has no `name`, and the raw CIO
// facet-option slug fallback in normalizeCategoryFacetDisplayNames) and the
// client cio-facet-adapter (humanizing a URL-selected facet value that CIO no
// longer returns). Both paths MUST use this one function so a stale-value pill
// renders identically to a present, humanized facet value (SFCC-11627).
export function humanizeCategoryId(id: string): string {
  if (!id) return "";
  return id
    .split(/[-_]+/)
    .filter(Boolean)
    .map(token => token[0]!.toUpperCase() + token.slice(1).toLowerCase())
    .join(" ");
}
